// extracted by mini-css-extract-plugin
export default {"app":"EditProfile1_app__3zvr8","headerBar":"EditProfile1_headerBar__d-d4b","view":"EditProfile1_view__Fl6oF","sumbitBtn":"EditProfile1_sumbitBtn__coI5G"};